import { render, staticRenderFns } from "./AppReviewOptions.vue?vue&type=template&id=15a0b82e&scoped=true"
import script from "./AppReviewOptions.vue?vue&type=script&lang=js"
export * from "./AppReviewOptions.vue?vue&type=script&lang=js"
import style0 from "./AppReviewOptions.vue?vue&type=style&index=0&id=15a0b82e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a0b82e",
  null
  
)

export default component.exports